$(document).ready(function() {
    /* $('#category').select2();
    $('#fee').select2(); */
    $(".datepicker").datepicker({
        todayHighlight: true,
        startDate: new Date()
    });
    /* Search By Category and Fee */
    /* $(document).on('change', '#category', function() {
        window.location.href = $(this).val();
    }); */

    /* $(document).on('change', '#fee', function() {
        var valSlug = $(this).val().toLowerCase().replace(/ /g, '-').replace(/\./g, '_');
        window.location.href = `${APP_BASE_URL}/celebrity/?fee=${valSlug}`;
    }); */

    /* $(document).on('click', '.search-key-btn', function() {
        $('#search-keyword-form').submit()
    }); */

    /*Speaker listing */
    $('.speaker-box').click(function(e) {
        if (e.target.className == 'book-now-button') {
            return false;
        }
        var l = $(this).data("href");
        if (l) {
            window.location = l;
        }
    });


   /*  $(".category-select,.fee-select").select2();
    $('.category-select,.fee-select').on('change', function() {
        var val = $(this).val();
        var valSlug = val.toLowerCase().replace(/ /g, '-').replace(/\./g, '_');
        if (val != "") {
            var name = $(this).attr('name');
            if (name == 'category')
                window.location.href = val;
            else
                window.location.href = "/celebrity/?" + name + "=" + valSlug;
        }
    }) */

    $('#speaker-form').validate({
        errorElement: "span",
        debug: false,
        rules: {
            name: {
                required: true,
            },
            email: {
                required: true,
                email: true
            },
            speakers: {
                required: true
            },
            fee: {
                required: true
            },
            service: {
                required: true
            }
        },
        submitHandler: function(form) {
            console.log('herer');
            form.submit();
        }
    });

    $('#archives').on('change',function(){
        var val = $(this).val();
        if(val){
            val = val.toLowerCase().split(" ");
            window.location.href = "/blog/archives/"+val[0]+"/"+val[1]+'/';
        } else {
            window.location.href = "/blog";
        }
    });

    $("#global_search_icon").click(function(){
        if($(this).hasClass('bi-search')){
            if(!$("#home-search").is(":visible")){
                $("#home-search").show();
                $(this).removeClass('bi-search').addClass('bi-x mobile-search-close');
                $('.search-main').addClass('mobile-search-main');
                $('#header').addClass('mobile-header');
            } else {
                if($("#home-search").val()){
                    $("form.search-main").submit();
                }
            }
        } else {
            $("#home-search").hide();
            $(this).addClass('bi-search').removeClass('bi-x mobile-search-close');
            $('.search-main').removeClass('mobile-search-main');
            $('#header').removeClass('mobile-header');
        }
    });

    const searchList = ['speaker-nav-item', 'fee-nav-item', 'location-nav-item'];
    $(document).on('click', '.speaker_search_form li.nav-item', function(e) {
        $(this).toggleClass('open');
        var actCls = $(this).attr('data-cus-cls');
        $.each(searchList, function(index, val) {
            if (val != actCls) {
                $('[data-cus-cls="'+val+'"]').removeClass('open');
            }
        });
    });

    /* $('body').on('click', function(e) {
        if ($('.speaker_search_form li.nav-item').hasClass('open')) {
            $('.speaker_search_form li.nav-item').removeClass('open');
        }
    }); */

    $("input.datepicker").click(function(){
        $(this).parent().find('.gj-icon').trigger('click');
    });
});


// WEBPACK FOOTER //
// ./public/themes/speakerbookingagency/v2/js/custom.js